import "./ee.css"

export default function EE() {
    return <div id="ee">
        <img src={`${process.env.PUBLIC_URL}/assets/ee.jpg`} alt="ee" height="20" width="20" />
    </div>
}